import { apiRequest } from './apiRequest';
import type { ContributorsResponse } from '../../types/api/contributor';

function buildContributorFiltersQuery(filters?: { timeframe?: string; status?: string }) {
  if (!filters) return '';
  const { timeframe, status } = filters;
  const params = new URLSearchParams();
  if (timeframe) params.set('timeframe', timeframe);
  if (status) params.set('status', status);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const contributorAPI = {
  getByRepository: async (
    repositoryId: string,
    filters?: { timeframe?: string; status?: string },
  ) => {
    const data = await apiRequest<ContributorsResponse>(
      `/api/repositories/${encodeURIComponent(repositoryId)}/contributors${buildContributorFiltersQuery(filters)}`,
      { method: 'GET' },
    );
    return data.contributors ?? [];
  },

  getByOrganisationAnalytics: async (
    organisationId: string,
    filters?: { timeframe?: string; status?: string },
  ) => {
    const data = await apiRequest<ContributorsResponse>(
      `/api/organisations/${encodeURIComponent(organisationId)}/contributor-analytics${buildContributorFiltersQuery(filters)}`,
      { method: 'GET' },
    );
    return data.contributors ?? [];
  },

  getByStream: async (
    organisationId: string,
    streamId: string,
    filters?: { timeframe?: string; status?: string },
  ) => {
    const data = await apiRequest<ContributorsResponse>(
      `/api/organisations/${encodeURIComponent(organisationId)}/streams/${encodeURIComponent(streamId)}/contributors${buildContributorFiltersQuery(filters)}`,
      { method: 'GET' },
    );
    return data.contributors ?? [];
  },

  getByProject: async (
    organisationId: string,
    streamId: string,
    projectId: string,
    filters?: { timeframe?: string; status?: string },
  ) => {
    const data = await apiRequest<ContributorsResponse>(
      `/api/organisations/${encodeURIComponent(organisationId)}/streams/${encodeURIComponent(
        streamId,
      )}/projects/${encodeURIComponent(projectId)}/contributors${buildContributorFiltersQuery(filters)}`,
      { method: 'GET' },
    );
    return data.contributors ?? [];
  },
};
